export const RESET_MODULE_STATE = 'RESET_MODULE_STATE'
export const SET_RESERVATIONS = 'SET_RESERVATIONS'
